import * as actionTypes from '../consts/actionTypes';
import { get } from '../helpers/http';
import { IPageDataReducer } from '../reducers/pageData';

export const getLivePositionData = (shipName) => (dispatch, getState) => {
    const { apiHost } = (getState().pageData as IPageDataReducer).appConfig;
    const url = `${apiHost}/ships/${shipName}/live-information/mobile`;
    return get(url)
        .then((payload) => {
            dispatch({
                type: actionTypes.loadShipLivePositionPageData,
                payload,
            });
        })
        .catch((error) => {
            throw error;
        }) as any;
};
